import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { HisNotificationService } from 'hisng';
import { Optional } from '../../../common/utils/optional';
import { BusinesstripApplication } from '../model/businesstripapplication';
import { BusinesstripApplicationService } from '../service/businesstripapplication.service';

@Component( {
    selector: 'erp-businesstripapplication-overview',
    templateUrl: './businesstripapplication-overview.component.html'
} )
export class BusinesstripApplicationOverviewComponent implements OnInit {

    businesstripApplication: BusinesstripApplication;
    formSaved: Subject<any> = new Subject();

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly notificationService: HisNotificationService,
        private readonly businesstripApplicationService: BusinesstripApplicationService,
    ) {
        this.businesstripApplication = this.router.getCurrentNavigation()?.extras.state as BusinesstripApplication;
    }

    ngOnInit() {
        if ( this.businesstripApplication === undefined ) {
            this.route.paramMap.subscribe( paramMap => {
                Optional.ofNullable( paramMap )
                    .map( ( m ) => m.get( 'id' ) )
                    .map( ( id ) => parseInt( id, 10 ) )
                    .ifPresent( ( id ) => {
                        this.subscribeToIdService( id );
                    } );
            } );
        } else {
            this.notificationService.successI18n( 'rm.erp.travelmanagement.businesstripapplication.application.save.success', 5000 );
        }
    }

    private subscribeToIdService( id: number ): void {
        this.businesstripApplicationService.getBusinesstripApplicationById( id ).subscribe( {
            next: ( businesstripApplicationCreated ) => {
                if ( businesstripApplicationCreated.id ) {
                    this.businesstripApplication = businesstripApplicationCreated;
                }
            },
            error: () => {
                this.notificationService.errorI18n( 'rm.erp.travelmanagement.businesstripapplication.application.get.error', 5000 );
            }
        } );
    }

    redirectToEditForm(): void {
        this.router.navigateByUrl( `/businesstripapplication/edit/${this.businesstripApplication.id}` );
    }

    notifyParentSaved() {
        this.formSaved.next( 1 );
    }
}
